"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _constants = require("./constants");

var _Typography = require("./components/Typography");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  component: _propTypes.object,
  variant: _propTypes.string,
  color: _propTypes.string
} : {};

var TypographyComponent = function TypographyComponent(_ref) {
  var CustomComponent = _ref.component,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body1' : _ref$variant,
      color = _ref.color,
      other = _objectWithoutProperties(_ref, ["component", "variant", "color"]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var Component = _react.default.useCallback(_Typography.Typography.withComponent(CustomComponent || _constants.VARIANTS[variant], {
    target: "e18lnfn40"
  }), [CustomComponent, variant]);

  return (0, _core.jsx)(Component, (0, _extends2.default)({
    variant: variant,
    color: color
  }, other));
};

exports.Typography = TypographyComponent;
process.env.NODE_ENV !== "production" ? TypographyComponent.propTypes = propTypes : void 0;